import React, {memo} from "react"
import style from "styles/isltoken.module.css"
import useLocale from '../../../../hooks/useLocale'

const IslToken = () => {
	const {islToken} = useLocale()

	return (
		<div className={style.token}>
			<div className={style.container}>
				<div className={style.mainBlock}>
					<div
						data-aos-once="true"
						data-aos="fade-right"
						data-aos-offset="100"
						data-aos-easing="ease-in-sine"
					>
						<h1 className={style.title}>{islToken.title}</h1>
						<h2 className={style.subtitle}>{islToken.subtitle}</h2>
					</div>

					<div className={style.tokenImage}>
						<img
							alt=""
							src="/image/token/islToken.webp"
							data-aos-once="true"
							data-aos="fade-left"
							data-aos-offset="100"
							data-aos-easing="ease-in-sine"
						/>

						<img
							alt=""
							src="/image/token/shadow.svg"
							data-aos-once="true"
							data-aos="fade-left"
							data-aos-offset="100"
							data-aos-easing="ease-in-sine"
						/>
					</div>

				</div>

				<span className={style.tokenEconomyTitle}>{islToken.tokenEconomy}</span>

				<div className={style.tokenEconomy}>
					<div
						data-aos-once="true"
						data-aos="fade-right"
						data-aos-offset="100"
						data-aos-easing="ease-in-sine"
					>
						<img data-aos="flip-right"
								 data-aos-easing="ease-out-cubic"
								 data-aos-duration="2000"  alt="" src="/image/token/playIncome.webp"/>

						<p className={style.tokenEconomySubtitle}>{islToken.playIncome}</p>

						<p className={style.smallTitle}>{islToken.playIncomeFirstTitle}</p>
						<p className={style.text}>{islToken.playIncomeFirstText}</p>

						<p className={style.smallTitle}>{islToken.playIncomeSecondTitle}</p>
						<p className={style.text}>{islToken.playIncomeSecondText}</p>

						<p className={style.smallTitle}>{islToken.playIncomeThirdTitle}</p>
						<p className={style.text}>{islToken.playIncomeThirdText}</p>
					</div>

					<div
						data-aos-once="true"
						data-aos="fade-left"
						data-aos-offset="100"
						data-aos-easing="ease-in-sine"
						className={style.secondBlockText}
					>
						<img data-aos="flip-left"
								 data-aos-easing="ease-out-cubic"
								 data-aos-duration="2000" alt="" src="/image/token/nftIncome.webp"/>

						<p className={style.tokenEconomySubtitle}>{islToken.nftIncome}</p>

						<p className={style.smallTitle}>{islToken.nftIncomeFirstTitle}</p>
						<p className={style.text}>{islToken.nftIncomeFirstText}</p>

						<p className={style.smallTitle}>{islToken.nftIncomeSecondTitle}</p>
						<p className={style.text}>{islToken.nftIncomeSecondText}</p>

						<p className={style.smallTitle}>{islToken.nftIncomeThirdTitle}</p>
						<p className={style.text}>{islToken.nftIncomeThirdText}</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default memo(IslToken)
